import axios from "axios";

export const categoriesData = () => {
    return axios
      .get("/categories")
      .then((response) => {
        // console.log(response.data);
        return response;
      });
  };